import React, { PureComponent } from 'react';
import { Col, Row } from 'react-bootstrap';
import './stepper.css';

class Stepper extends PureComponent {
  render() {
    const { step } = this.props;

    return (
      <Row noGutters>
        <Col>
          <div className="stepper">
            <ul className="progressbar">
              <li className={step >= 1 ? 'active' : ''}>
                <span>Características del Depósito</span>
              </li>
              <li className={step >= 2 ? 'active' : ''}>
                <span>Resultados de la Simulación</span>
              </li>
              <li className={step >= 3 ? 'active' : ''}>
                <span>Confirmación y Contrato</span>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    );
  }
}

export default Stepper;
